import { get } from 'lodash';
import { sendFandomAnalyticsEvent } from "src/modules/fandom_analytics_module.js";

function addDigitalDataEvent(eventInfo, category, linkNameSuffix=null) {
  const event = {
    eventInfo: {
      eventName: eventInfo
    },
    category: {
      eventName: category
    }
  }
  if (!!window.wa_gc) {
    const digitalData = Fandom.deepClone(window.digitalData);
    digitalData.event = [event];
    console.log("%Added digitalData event", "background: #222; color: #bada55; padding: .5rem;", digitalData.event);
    digitalData.link_name = `${getPageName()}${linkNameSuffix}`;
    window.wa_gc(digitalData, "link");
    console.log("%cExecuted wa_gc(digitalData, 'link')", "background: #222; color: #bada55; padding: .5rem;", digitalData);
  }
}

function getPageName() {
  return get(window.digitalData, ['page', 'pageInfo', 'pageName']);
}

function trackInteractionAttempt(interactionRecord) {
  const trackingString = get(interactionRecord, ["button_tracking"], false);
  if (trackingString) {
    const trackingParams = trackingString.split(",");
    sendFandomAnalyticsEvent(trackingParams[0], trackingParams[1], trackingParams[2]);
  }
}

function checkForInteractionAvailability(interactionRecord, callback) {
  if (get(interactionRecord, ["registration_needed"], false) && !Fandom.isUserRegistered()) {
    trackInteractionAttempt(interactionRecord);
    $("#modal-registration").modal("show");
  } else if (get(interactionRecord, ["profile_completion_needed"], false)) {
    trackInteractionAttempt(interactionRecord);
    const mockedContent = {
      name: `mocked-content-${globalState.pageModel.main_content_name}-${interactionRecord.$id}`
    }
    Vue.set(globalState.pageModel.name_to_content_authorization, mockedContent.name, {
      data: {
        authorization_type_to_authorized: {},
        authorization_record: {
          user_group: interactionRecord.user_group
        }
      }
    });
    Fandom.emit('modal-user-group-required', mockedContent);
  } else {
    callback();
  }
}

const targetTagToUrl = {
  'target-soho': '/partita-iva-professionisti',
  'target-sme': '/piccole-medie-aziende',
  'target-corporate': '/grandi-aziende',
  'target-pubblica-amministrazione': '/pubblica-amministrazione'
}

const VodafoneLab = {
  addDigitalDataEvent,
  getPageName,
  targetTagToUrl,
  checkForInteractionAvailability
};

export { VodafoneLab };
